import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import {Container, Row, Col} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099Why.module.scss'
const cx = cn.bind(s)

interface IMake1099WhyProps {
	className?: string
	content: IMake1099Content['why']
}

/** Make1099Why block component */
const Make1099Why: FC<IMake1099WhyProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<ul className={s.list}>
							{content?.items?.map((item) => (
								<li key={item._key || item.title} className={s.item}>
									<h3 className={cx('itemTitle', 'h3')}>{item.title}</h3>
									<p className={s.itemDescription}>{item.description}</p>
								</li>
							))}
						</ul>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

Make1099Why.displayName = 'Make1099Why'

export default Make1099Why
